import { Link } from 'react-router-dom'
import { MapPin, Radio, ChevronRight, Github, Cloud, Clock } from 'lucide-react'
import { Section } from '@/components/Section'
import { PushSettings } from '@/features/push/PushSettings'
import { ClockToggle } from '@/features/globe/globe-chrome'
import { useLocationStore } from '@/store/location'
import { usePrefs } from '@/store/prefs'
import './settings.css'

export function SettingsView() {
  const saved = useLocationStore((s) => s.saved)
  const count = useLocationStore((s) => s.list.length)
  const clock = usePrefs((s) => s.clock)
  const toggleClock = usePrefs((s) => s.toggleClock)

  return (
    <div className="settings">
      <header className="view-head">
        <h1 className="view-title">Settings</h1>
      </header>

      <Section label="Locations">
        <Link to="/locations" className="card setrow setrow--link">
          <div className="setrow__main">
            <MapPin size={18} className="setrow__icon" />
            <div>
              <p className="setrow__title">{saved ? saved.label : 'Set your location'}</p>
              <p className="setrow__sub">
                {count > 0
                  ? `${count} saved · search, switch, manage`
                  : 'Search a city or use your location'}
              </p>
            </div>
          </div>
          <ChevronRight size={18} className="setrow__chev" />
        </Link>
      </Section>

      <Section label="Display">
        <div className="card setrow">
          <div className="setrow__main">
            <Clock size={18} className="setrow__icon" />
            <div>
              <p className="setrow__title">Time format</p>
              <p className="setrow__sub">
                {clock === '24h' ? '24-hour · 15:30' : '12-hour · 3:30 PM'}
              </p>
            </div>
          </div>
          <ClockToggle clock={clock} onToggle={toggleClock} />
        </div>
      </Section>

      <Section label="Alerts">
        <PushSettings />
      </Section>

      <Section label="Labs">
        <Link to="/storm" className="card setrow setrow--link">
          <div className="setrow__main">
            <Radio size={18} className="setrow__icon setrow__icon--storm" />
            <div>
              <p className="setrow__title">Storm Mode (preview)</p>
              <p className="setrow__sub">The war-room view — arriving in Milestone 2.</p>
            </div>
          </div>
          <ChevronRight size={18} className="setrow__chev" />
        </Link>
      </Section>

      <Section label="About">
        <div className="card about">
          <p className="about__line">
            <Cloud size={15} /> Conditions, forecast &amp; alerts from the{' '}
            <a href="https://www.weather.gov/documentation/services-web-api" target="_blank" rel="noreferrer">
              NWS API
            </a>
            .
          </p>
          <p className="about__line">
            <Github size={15} /> Products &amp; the national pulse from Triple-A’s R2 feeds.
          </p>
          <p className="about__version num">Triple-A Weather · PWA v0.1.0 · Milestone 1</p>
        </div>
      </Section>
    </div>
  )
}
